import * as React from 'react';
import * as ReactDom from 'react-dom';
import $ from 'jquery';
export class PopupConfirmationWindow extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    ok() {
        this.props.OkMethod();
    }
    
    closePopUp() {
        $("#popUpConfirmModel").hide();
    }



    public render() {
        return <div className="modal" id="popUpConfirmModel" role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Confirmation </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={this.closePopUp.bind(this)}>&times;</button>                       
                    </div>
                    <div className="modal-body">
                        <div className='alert mb-0'>
                            {this.props.Message}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" id="btnYes" className="btn btn-primary" onClick={this.ok.bind(this)}>Ok</button>
                    </div>
                </div>
            </div>
        </div>
    }
}
export class PopupConfirmWindow extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }
    static close() {
        $("#popUpConfirmModel .close").click();
    }
    static showConfirmBox(Message, OkMethod) {
        ReactDom.render(<PopupConfirmationWindow Message={Message} OkMethod={OkMethod} />, document.getElementById('divMsgboxDynamicContent'));
        setTimeout(function () {
            $('#popUpConfirmModel').show();
        }, 50);
    }

    public render() {
        return <div >
        </div>
    }
}